module.exports = __webpack_public_path__ + "img/device-lost.5f913994.svg";